import React, { Component, createRef } from 'react';
import { withTranslation } from 'react-i18next';

import classes from './Carousel.module.css';
import { ReactComponent as ArrowLeftIcon } from '../../../assets/icons/arrow-left-icon.svg';
import { ReactComponent as ArrowRigthIcon } from '../../../assets/icons/arrow-right-icon.svg';

class Carousel extends Component {

  constructor(props) {
    super(props);
    this.itemsContainerRef = createRef();
  }
  
  state={
    // those two variables are not used in this project.
    showLeftArroy: false, 
    showRightArrow: false
  }

  mouseDown= null;
  keyDown= null;

  componentDidMount(){
    if (this.itemsContainerRef.current.scrollWidth>this.itemsContainerRef.current.clientWidth){
      this.setState({showRightArrow: true})
    }

    // focusing the carusel
    this.carouselRef.focus();
    
  }


  mouseUpHandler = () =>{
    clearInterval(this.mouseDown);
    this.keyDown = false;
  }

  arrowKeypress = e => {
    //it triggers to move carousel with keyboard arrows

    if (e.keyCode === 37 && !this.keyDown) {
      this.keyDown = true;
      this.scrollLeftHandler();
    }
    if (e.keyCode === 39 && !this.keyDown) {
      this.keyDown = true;
      this.scrollRightHandler();
    }
  };

  leftKeypress = e => {
    //it triggers by pressing the enter or space key
    if ((e.keyCode === 13 || e.keyCode === 32) && !this.keyDown) {
      this.keyDown = true;
      this.scrollLeftHandler();
    }
  };
  rightKeypress = e => {
    //it triggers by pressing the enter or space key
    if ((e.keyCode === 13 || e.keyCode === 32) && !this.keyDown) {
      this.keyDown = true;
      this.scrollRightHandler();
    }
  };


  scrollLeftHandler = () =>{
    this.mouseDown = setInterval(()=>{
        this.itemsContainerRef.current.scrollLeft = this.itemsContainerRef.current.scrollLeft - 5;
        if(this.itemsContainerRef.current.scrollLeft <=0 ) {
          this.setState({showLeftArroy: false});
          this.mouseUpHandler(); // mouseUp cause button desapears and mouseUp event deseapears as well
        }
        if(this.itemsContainerRef.current.scrollLeft < this.itemsContainerRef.current.scrollWidth) this.setState({showRightArrow: true})
    },5);
  }

  scrollRightHandler = () =>{
    this.mouseDown = setInterval(()=>{
      this.itemsContainerRef.current.scrollLeft = this.itemsContainerRef.current.scrollLeft + 5;
      if(this.itemsContainerRef.current.scrollLeft > 0) this.setState({showLeftArroy: true});
      if(this.itemsContainerRef.current.scrollLeft >= this.itemsContainerRef.current.scrollWidth-this.itemsContainerRef.current.clientWidth) {
        this.setState({showRightArrow: false})
        this.mouseUpHandler(); // mouseUp cause button desapears and mouseUp event deseapears as well
      }
    },5);
  }

  render(){

    const messageClasses = [
      classes[`${this.props.origin}-message`],
      classes.Carousel
    ];

    const leftArrow = (
      <button 
        className={[classes.Arrow, classes.ArrowLeft].join(' ')}
        onMouseDown={this.scrollLeftHandler}
        onMouseUp={this.mouseUpHandler}
        onKeyDown={this.leftKeypress}
        onKeyUp={this.mouseUpHandler}
        title={this.props.t('carousel.arrow.left')} 
        aria-label={this.props.t('carousel.arrow.left')}> 
        <ArrowLeftIcon/>
      </button>
    )

    const rightArrow = (
      <button 
        className={[classes.Arrow, classes.ArrowRight].join(' ')}
        onMouseDown={this.scrollRightHandler}
        onMouseUp={this.mouseUpHandler}
        onKeyDown={this.rightKeypress}
        onKeyUp={this.mouseUpHandler}
        title={this.props.t('carousel.arrow.rigth')} 
        aria-label={this.props.t('carousel.arrow.rigth')}> 
        <ArrowRigthIcon/>
      </button>
    )

    return (
      <div 
        className={messageClasses.join(' ')} 
        ref={(item) => { this.carouselRef = item; }} 
        style={this.props.style} 
        role="region" 
        tabIndex='0'
        onKeyDown={this.arrowKeypress}
        onKeyUp={this.mouseUpHandler}
        aria-labelledby="carouselTitle">
        <h4 id="carouselTitle" className="sr-only"> {this.props.t('carousel.title')} </h4>
        <div className={classes.ItemsContainer} ref={this.itemsContainerRef} >
          {this.props.children}
        </div>
        {this.props.children.length>1 ? 
          <div className={classes.ArrowContainer}>
            {leftArrow}
            {rightArrow}
          </div>
           : ''
        }
      </div>
    )
  }
    
}


export default  withTranslation('global')(Carousel);